import React from 'react';

import { Link } from 'react-router-dom';

import { StyledError } from './Error.styled';

const Error = ({ error }) => {
  return (
    <StyledError>
      <h1>Error {error?.status || 404}</h1>
      <h2>Something went wrong.</h2>
      <p>{error?.message || 'Content not found. Please try again.'}</p>
      <Link to={'/'}>Go Home</Link>
    </StyledError>
  );
};

export default Error;

